let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fbCuk")).then(() => parcelRequire('5DizY'));